import Pagination from 'vue-pagination-2'
import Calendar from './Calendar'
import Spinner from './Spinner'
import Paginator from './Paginator'

export default {
  install (Vue) {
    Vue.component('pagination', Pagination)
    Vue.component('Calendar', Calendar)
    Vue.component('Spinner', Spinner)
    Vue.component('paginator', Paginator)
  }
}
